import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetTmpTradesRequestModel, GetTmpTradesResponseModel } from "@/features/accounts/ocr/services/get-tmp-trades-model";

export class GetTmpTradesApi {
  /**
   * OCR取込結果表示API
   */
  public GetTmpTrades = async (
    param: GetTmpTradesRequestModel
  ): Promise<GetTmpTradesResponseModel[]> => {
    const path = `/api/ocraccounts/tmptrades`;

    const res = await ApiClient.instance.get<GetTmpTradesResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
